import {AfterViewChecked, Component, OnInit, ViewChild} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

import { AdminService } from '../../../services/admin.service';
import { Observable, Subject } from 'rxjs';
import { User } from '../../../Models/user';

import { BusinessProcess } from '../../../Models/businessProcess';
import { DropDownContent } from '../../../Models/dropDownContent';
import { BusinessProcessService } from '../../../services/business-process.service';
import { AccessControlService } from '../../../services/access-control.service';
import { SecurableObjectType } from '../../../Models/enum/securableObjectType';
import { SecurableObjectAcessControlEntry } from '../../../Models/SecurableObjectAcessControlEntry';

import { TrusteeType } from '../../../Models/enum/trusteeType';
import { GenericModalService } from '../../../services/generic-modal.service';
import { AccessControlModalComponent } from './access-control-modal.component';
import {FormsValidatorService} from '../../../services/forms-validator.service';
import {CustomValidator} from '../../../services/custom-validator';
import {DropdownMultiselectComponent} from '../../../common/dropdown-multiselect/dropdown-multiselect.component';



@Component({
  selector: 'app-state-access-control',
  templateUrl: './access-control.component.html',
  styleUrls: ['./access-control.component.css']
})
export class AccessControlComponent implements OnInit, AfterViewChecked {

  @ViewChild('childPermissionDropDown', {static: false}) childPermissionDropDown: DropdownMultiselectComponent;
  @ViewChild('childStateDropDown', {static: false}) childStateDropDown: DropdownMultiselectComponent;
  @ViewChild('childUsersDropDown', {static: false}) childUsersDropDown: DropdownMultiselectComponent;
  @ViewChild('childGroupsDropDown', {static: false}) childGroupsDropDown: DropdownMultiselectComponent;

  bpName: string;
  rota = this.router.url;
  availableStates: DropDownContent[];
  selectedItemsStates = [];

  availablePermissions: DropDownContent[];
  dmAvailablePermissions = [];
  selectedPermissions = [];

  availableUsers: DropDownContent[];
  selectedUsers = [];

  availableGroups: DropDownContent[];
  selectedGroups = [];

  availableBusinessProcess: Observable<BusinessProcess[]>;

  securableObjectAccessControlEntries: SecurableObjectAcessControlEntry[];
  securableObjectAccessForm: FormGroup;

  error = '';
  deleteError = '';
  deletePleaseWait = false;
  searchPleaseWait = false;
  submitted = false;
  haveRecords = false;
  onInit = true;
  public disableBtn = true;
  destComponent: any = AccessControlModalComponent;

  get formData() { return this.securableObjectAccessForm.controls; }

  constructor(
              private formBuilder: FormBuilder,
              private admService: AdminService,
              private bpService: BusinessProcessService,
              private accessControl: AccessControlService,
              private modalService: GenericModalService,
              private router: Router) { }

  ngOnInit() {
    this.onInit = true;
    this.createForm();
    this.loadDropDowns();
    this.availableBusinessProcess = this.bpService.getAllBusinessProcesses();
    if (this.rota === '/extractionAccessControl') {
      FormsValidatorService.removeValidator( this.securableObjectAccessForm, 'securableObjects');
    }
  }

  ngAfterViewChecked() {
    const listItems = <HTMLCollectionOf<Element>>document.getElementsByClassName('ng-option');
    if (this.availableGroups) {
      this.changeColorData(listItems, this.availableGroups);
    }

    if (this.availableUsers) {
      this.changeColorData(listItems, this.availableUsers);
    }
  }

  changeColorData(listItems: HTMLCollectionOf<Element>, availableItems: DropDownContent[]) {
    availableItems.forEach( item => {
      for (let i = 0 ; i < listItems.length ; i++ ) {
        if ( !item.enabled && item.name === (<HTMLElement>listItems[i].children[0]).innerText )  {
          let item = <HTMLElement>listItems[i].children[0];
          item.style.color = '#ccc';
        }
      }
    });
  }

  loadDropDowns() {
    this.loadPermissions();
    this.loadUsersDropdown();
    this.loadGroupsDropdown();
  }

  loadUsersDropdown() {
    this.admService.loadDropdownContent('api/admin/loadAllUsersDropDown')
      .subscribe(result => this.availableUsers = result, error => this.error = error);
  }

  loadGroupsDropdown() {
    this.admService.loadDropdownContent('api/loadAllGroupsDropdown')
      .subscribe(result => this.availableGroups = result, error => this.error = error);
  }

  loadStates() {
    // this.childStateDropDown.reset();
    this.selectedItemsStates = [];
    const bp = (document.getElementById('businessProcess')) as HTMLSelectElement;
    this.bpName = bp.options[bp.selectedIndex].text;
    this.bpService.getStatesByBusinessProcessName(this.bpName)
      .subscribe(result => {
        this.availableStates = result;
        if (result.length > 0) {
          this.securableObjectAccessForm.get('securableObjects').enable();
        } else {
          this.securableObjectAccessForm.get('securableObjects').disable();
        }

        }, error => this.error = error
      );
  }

  loadPermissions() {
    this.accessControl.getSecurableObjectPermissions(SecurableObjectType.state)
      .subscribe(result => {
          this.availablePermissions = result;
          this.dmAvailablePermissions = result.map(m => ({ id: m.id, label: m.name }));
        }, error => console.error(error)
      );
  }

  createForm() {
    this.securableObjectAccessForm = this.formBuilder.group({
      businessProcessId: [0, CustomValidator.singleDropdown],
      businessProcessName: [[]],
      securableObjects: [{ value: [], disabled: true}, Validators.required],
      users: [[]],
      groups: [[]],
      permissions: [[]],
      securableObjectType: []
    });
  }

  resetFilter() {
    // reset dos campos do form deste component.
    this.securableObjectAccessForm.reset();

    // desabilitar o estado até que seja selecionado um processo de negócio.
    this.securableObjectAccessForm.get('securableObjects').disable();

    // limpar os estados para que seja carregado novamente ao selecionar um processo de negócio.
    this.availableStates = [];

    // reset dos elementos genericos
    this.resetCustomDropdown();
  }

  resetCustomDropdown() {
    // chamar o reset do form do dropdown generico para limpar a seleção
    this.childUsersDropDown.reset();
    this.childGroupsDropDown.reset();

    // necessario para limpar os itens selecionados
    this.selectedUsers = [];
    this.selectedGroups = [];

    if (this.rota === '/stateAccessControl') {
      this.childPermissionDropDown.reset();
      this.selectedPermissions = [];
    }
  }

  getFilteredData(filter: any[], availableItems: DropDownContent[]) {
    return availableItems.filter(f => filter.indexOf(f.id) > -1).map(m => ({ id: m.id, name: m.name }));
  }

  search() {
    // nao eh mais inicializacao
    this.onInit = false;

    // exibir a mensagem de Aguarde
    this.searchPleaseWait = true;

    const filter = this.securableObjectAccessForm.getRawValue();

    if (this.rota === '/stateAccessControl') {
      filter.securableObjectType = SecurableObjectType.state;
      filter.securableObjects = !filter.securableObjects ? [] : this.getFilteredData(filter.securableObjects, this.availableStates);
    } else {
      filter.securableObjectType = SecurableObjectType.businessProcess;
      filter.securableObjects = [{
        id: filter.businessProcessId as number,
        name: this.bpName
      }];
    }
    // filter.users = !filter.users ? [] : this.getFilteredData(filter.users, this.availableUsers);
    filter.users = this.getFilteredData(this.selectedUsers, this.availableUsers);
    // filter.groups = !filter.groups ? [] : this.getFilteredData(filter.groups, this.availableGroups);
    filter.groups = this.getFilteredData(this.selectedGroups, this.availableGroups);
    // filter.permissions = !filter.permissions ? [] : this.getFilteredData(filter.permissions, this.availablePermissions);
    filter.permissions = this.getFilteredData(this.selectedPermissions, this.availablePermissions);

    filter.businessProcessName = this.bpName;

    this.deleteError = '';
    this.error = '';
    this.accessControl.getAccessControlEntries(filter)
      .subscribe(result => {
        this.securableObjectAccessControlEntries = result;

        this.haveRecords = result.length > 0;

        // recolher os filtros, para melhor visualização do resultado
        document.getElementById('cardFilter').classList.add('collapsed-card');
        document.getElementById('bodyFilter').style.display = 'none';
        document.getElementById('footerFilter').style.display = 'none';

        // ocultar a mensagem de Aguarde
        this.searchPleaseWait = false;

        // fechar o filtro
        const collapseFilter = document.getElementById('collapseFilter');
        collapseFilter.classList.add('fa-plus');
        collapseFilter.classList.remove('fa-minus');

        }, error => {
        // ocultar a mensagem de Aguarde
        this.searchPleaseWait = true;

        this.error = error;
        console.error(error);
      });

  }

  public selectAll(element) {
    const selectAllChecked = element.target.checked;
    this.disableBtn = !selectAllChecked;

    const aCheckBox = document.getElementsByClassName('checkbox-selection');
    for (let i = 0; i < aCheckBox.length; i++) {
      const item = <HTMLInputElement>document.getElementById(aCheckBox[i].id);
      item.checked = selectAllChecked;
    }
  }

  public chkActions(element) {
    // verificar se deve habilitar ou desabilitar os botões de excluir.
    this.disableBtnDelete();
  }

  disableBtnDelete() {
    let btn = false;
    const aCheckBox = document.getElementsByClassName('checkbox-selection');
    for (let i = 0; i < aCheckBox.length; i++) {
      const item = <HTMLInputElement>document.getElementById(aCheckBox[i].id);
      if (item.checked) {
        btn = true;
        break;
      }
    }
    this.disableBtn = !btn;
  }

  removeAccessControlEntries() {
    this.deleteError = '';
    this.submitted = false;
    // exibir a mensagem de Aguarde
    this.deletePleaseWait = true;

    const params = this.getCheckedItems();

    this.accessControl.deleteAccessControlEntries(params).subscribe(result => {
      // ocultar a mensagem de Aguarde
      this.deletePleaseWait = false;

      // exibir a mensagem de Exclusão realizada com sucesso.
      this.submitted = true;

      this.disableBtn = true;
      setTimeout(() => {
        this.submitted = false;
        this.search();
        const selectAll = <HTMLInputElement>document.getElementById('checkbox-selectAll');
        selectAll.checked = false;
        }, 2000);
    }, error => {
      // ocultar a mensagem de Aguarde
      this.deletePleaseWait = false;

      this.deleteError = error;
      console.error(error);
    });
  }

  getCheckedItems() {
    const aCheckBox = document.getElementsByClassName('checkbox-selection');
    const arr = [];

    for (let i = 0; i < aCheckBox.length; i++) {
      const item = <HTMLInputElement>document.getElementById(aCheckBox[i].id);
      if (item.checked) {
        const accessControlEntryId = parseFloat(item.getAttribute('data-accessControlEntryId'));
        // buscar no resultado da pesquisa, os itens pelo accessControlEntryId
        const result = this.securableObjectAccessControlEntries.filter((f) => f.accessControlEntryId === accessControlEntryId)[0];

        arr.push({
          accessControlEntryId: result.accessControlEntryId,
          trusteeId: result.trusteeId,
          trusteeType: (result.trusteeType === 'User' ? TrusteeType.user : TrusteeType.group) as TrusteeType,
          securableObjectId: result.securableObjectId,
          securableObjectType:
            (this.rota === '/stateAccessControl' ? SecurableObjectType.state : SecurableObjectType.businessProcess) as SecurableObjectType,
          accessControlPermissionId: result.accessControlPermissionId,
          accessControlPermissionName: result.accessControlPermissionName
        });
      }
    }
    return arr;
  }

  onAddNew() {
    let securableObjectTitle = 'Conceder novo acesso ';
    let securableObjectType = 0;

    if (this.rota === '/stateAccessControl') {
      securableObjectTitle += 'de Estado';
      securableObjectType = SecurableObjectType.state;
    } else {
      securableObjectTitle += 'de Extração';
      securableObjectType = SecurableObjectType.businessProcess;
    }

    const result$ = this.modalService.showModal(this.destComponent, securableObjectTitle, securableObjectType);
  }

  onSelectAll(availableItems: DropDownContent[], path: string, formGroup: FormGroup) {
    const selected = availableItems.map(item => item.id);
    formGroup.get(path).patchValue(selected);
  }

  onClearAll(path: string, formGroup: FormGroup) {
    formGroup.get(path).patchValue([]);
  }

  getSelectedStates(element) {
    this.selectedItemsStates = element;
  }

  getSelectedPermissions(element) {
    this.selectedPermissions = element;
  }

  getSelectedUsers(element) {
    this.selectedUsers = element;
  }

  getSelectedGroups(element) {
    this.selectedGroups = element;
  }

}
